import React from 'react'

import StoreDetailsModal from './StoreDetailsModal'

function Modals() {
  return <StoreDetailsModal />
}

export default Modals
